import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <ul class="search-menu-assistant">
  {{! suggestion type keywords are mapped to SUGGESTION_KEYWORD_MAP }}
  {{#if (eq this.suggestionType "tagIntersection")}}
    {{#each @results as |result|}}
      <SearchMenu::Results::AssistantItem
        @tag={{result.tagName}}
        @additionalTags={{result.additionalTags}}
        @category={{result.category}}
        @slug={{@slug}}
        @withInLabel={{@withInLabel}}
        @isIntersection={{true}}
        @searchAllTopics={{true}}
        @closeSearchMenu={{@closeSearchMenu}}
        @searchTermChanged={{@searchTermChanged}}
        @suggestionKeyword={{@suggestionKeyword}}
      />
    {{/each}}
  {{else if (eq this.suggestionType "categoryOrTag")}}
    {{#each @results as |result|}}
      {{#if result.model}}
        {{! render category }}
        <SearchMenu::Results::AssistantItem
          @category={{result.model}}
          @slug={{get this.fullSlugForCategoryMap result.model.id}}
          @withInLabel={{@withInLabel}}
          @searchAllTopics={{true}}
          @closeSearchMenu={{@closeSearchMenu}}
          @searchTermChanged={{@searchTermChanged}}
          @suggestionKeyword={{@suggestionKeyword}}
        />
      {{else}}
        {{! render tag }}
        <SearchMenu::Results::AssistantItem
          @tag={{result.name}}
          @slug={{concat this.prefix "#" result.name}}
          @withInLabel={{@withInLabel}}
          @searchAllTopics={{true}}
          @closeSearchMenu={{@closeSearchMenu}}
          @searchTermChanged={{@searchTermChanged}}
          @suggestionKeyword={{@suggestionKeyword}}
        />
      {{/if}}
    {{/each}}
  {{else if (eq this.suggestionType "user")}}
    {{#if this.userMatchesInTopic}}
      <SearchMenu::Results::AssistantItem
        @extraHint={{true}}
        @user={{this.user}}
        @slug={{concat this.prefix "@" this.user.username}}
        @suffix={{i18n "search.in_topics_posts"}}
        @searchAllTopics={{true}}
        @closeSearchMenu={{@closeSearchMenu}}
        @searchTermChanged={{@searchTermChanged}}
        @suggestionKeyword={{@suggestionKeyword}}
      />

      <SearchMenu::Results::AssistantItem
        @user={{this.user}}
        @slug={{concat this.prefix "@" this.user.username}}
        @suffix={{i18n "search.in_this_topic"}}
        @closeSearchMenu={{@closeSearchMenu}}
        @searchTermChanged={{@searchTermChanged}}
        @suggestionKeyword={{@suggestionKeyword}}
      />
    {{else}}
      {{#each @results as |result|}}
        <SearchMenu::Results::AssistantItem
          @user={{result}}
          @slug={{concat this.prefix "@" result.username}}
          @searchAllTopics={{true}}
          @closeSearchMenu={{@closeSearchMenu}}
          @searchTermChanged={{@searchTermChanged}}
          @suggestionKeyword={{@suggestionKeyword}}
        />
      {{/each}}
    {{/if}}
  {{else}}
    {{#each this.suggestionShortcuts as |item|}}
      <SearchMenu::Results::AssistantItem
        @slug={{concat this.prefix item}}
        @label={{item}}
        @searchAllTopics={{true}}
        @closeSearchMenu={{@closeSearchMenu}}
        @searchTermChanged={{@searchTermChanged}}
        @suggestionKeyword={{@suggestionKeyword}}
      />
    {{/each}}
  {{/if}}
</ul>
*/
{
  "id": "BWBdEXaT",
  "block": "[[[10,\"ul\"],[14,0,\"search-menu-assistant\"],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"suggestionType\"]],\"tagIntersection\"],null],[[[42,[28,[37,3],[[28,[37,3],[[30,1]],null]],null],null,[[[1,\"      \"],[8,[39,4],null,[[\"@tag\",\"@additionalTags\",\"@category\",\"@slug\",\"@withInLabel\",\"@isIntersection\",\"@searchAllTopics\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[30,2,[\"tagName\"]],[30,2,[\"additionalTags\"]],[30,2,[\"category\"]],[30,3],[30,4],true,true,[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[2]],null]],[]],[[[41,[28,[37,1],[[30,0,[\"suggestionType\"]],\"categoryOrTag\"],null],[[[42,[28,[37,3],[[28,[37,3],[[30,1]],null]],null],null,[[[41,[30,8,[\"model\"]],[[[1,\"        \"],[8,[39,4],null,[[\"@category\",\"@slug\",\"@withInLabel\",\"@searchAllTopics\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[30,8,[\"model\"]],[28,[37,5],[[30,0,[\"fullSlugForCategoryMap\"]],[30,8,[\"model\",\"id\"]]],null],[30,4],true,[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,4],null,[[\"@tag\",\"@slug\",\"@withInLabel\",\"@searchAllTopics\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[30,8,[\"name\"]],[28,[37,6],[[30,0,[\"prefix\"]],\"#\",[30,8,[\"name\"]]],null],[30,4],true,[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[]]]],[8]],null]],[]],[[[41,[28,[37,1],[[30,0,[\"suggestionType\"]],\"user\"],null],[[[41,[30,0,[\"userMatchesInTopic\"]],[[[1,\"      \"],[8,[39,4],null,[[\"@extraHint\",\"@user\",\"@slug\",\"@suffix\",\"@searchAllTopics\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[true,[30,0,[\"user\"]],[28,[37,6],[[30,0,[\"prefix\"]],\"@\",[30,0,[\"user\",\"username\"]]],null],[28,[37,7],[\"search.in_topics_posts\"],null],true,[30,5],[30,6],[30,7]]],null],[1,\"\\n\\n      \"],[8,[39,4],null,[[\"@user\",\"@slug\",\"@suffix\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[30,0,[\"user\"]],[28,[37,6],[[30,0,[\"prefix\"]],\"@\",[30,0,[\"user\",\"username\"]]],null],[28,[37,7],[\"search.in_this_topic\"],null],[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[]],[[[42,[28,[37,3],[[28,[37,3],[[30,1]],null]],null],null,[[[1,\"        \"],[8,[39,4],null,[[\"@user\",\"@slug\",\"@searchAllTopics\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[30,9],[28,[37,6],[[30,0,[\"prefix\"]],\"@\",[30,9,[\"username\"]]],null],true,[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[9]],null]],[]]]],[]],[[[42,[28,[37,3],[[28,[37,3],[[30,0,[\"suggestionShortcuts\"]]],null]],null],null,[[[1,\"      \"],[8,[39,4],null,[[\"@slug\",\"@label\",\"@searchAllTopics\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[28,[37,6],[[30,0,[\"prefix\"]],[30,10]],null],[30,10],true,[30,5],[30,6],[30,7]]],null],[1,\"\\n\"]],[10]],null],[1,\"  \"]],[]]]],[]]]],[]]],[13]],[\"@results\",\"result\",\"@slug\",\"@withInLabel\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\",\"result\",\"result\",\"item\"],false,[\"if\",\"eq\",\"each\",\"-track-array\",\"search-menu/results/assistant-item\",\"get\",\"concat\",\"i18n\"]]",
  "moduleName": "discourse/components/search-menu/results/assistant.hbs",
  "isStrictMode": false
});